import { render, staticRenderFns } from "./add-staff.vue?vue&type=template&id=e15cf6d6&scoped=true"
import script from "./add-staff.vue?vue&type=script&lang=js"
export * from "./add-staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15cf6d6",
  null
  
)

export default component.exports